import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { SUPPORT_EMAIL } from './constants'

const t = buildTranslate('promo_codes.olo_config.steps')

const NUMBER_BADGE_SIZE = 28
const CONNECTOR_WIDTH = 2
const CONNECTOR_MIN_HEIGHT = 16
const STEP_VERTICAL_GAP = 24

const StepTimeline = () => {
  const [css] = useStyletron()

  const steps: { key: string; title: string; body: React.ReactNode }[] = [
    { key: 'copy', title: t('copy.title'), body: t('copy.body') },
    {
      key: 'email',
      title: t('email.title'),
      body: (
        <>
          {t('email.body_prefix')}{' '}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className={css({ color: palette.belizeHole })}
          >
            {SUPPORT_EMAIL}
          </a>{' '}
          {t('email.body_suffix')}
        </>
      ),
    },
    { key: 'handoff', title: t('handoff.title'), body: t('handoff.body') },
  ]

  return (
    <ol
      // list-style: none drops the list role in Safari VoiceOver, so restore it
      // explicitly to keep the ordered-sequence semantics (WCAG 1.3.1).
      role="list"
      className={css({
        display: 'flex',
        flexDirection: 'column',
        listStyle: 'none',
        padding: 0,
        margin: 0,
      })}
    >
      {steps.map((step, index) => {
        const isLastStep = index === steps.length - 1
        return (
          <li
            key={step.key}
            data-testid={`olo-step-${step.key}`}
            className={css({ display: 'flex', gap: '8px' })}
          >
            <div
              aria-hidden="true"
              className={css({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                alignSelf: 'stretch',
              })}
            >
              <div
                className={css({
                  flexShrink: 0,
                  width: `${NUMBER_BADGE_SIZE}px`,
                  height: `${NUMBER_BADGE_SIZE}px`,
                  borderRadius: '50%',
                  backgroundColor: palette.belizeHole10,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                })}
              >
                <Text.BodyText4 bold color="belizeHole" tag="span">
                  {index + 1}
                </Text.BodyText4>
              </div>
              {!isLastStep && (
                <div
                  className={css({
                    width: `${CONNECTOR_WIDTH}px`,
                    flex: '1 1 auto',
                    minHeight: `${CONNECTOR_MIN_HEIGHT}px`,
                    marginTop: '4px',
                    marginBottom: '4px',
                    backgroundColor: palette.grey30,
                  })}
                />
              )}
            </div>
            <div
              className={css({
                paddingBottom: isLastStep ? '0' : `${STEP_VERTICAL_GAP}px`,
              })}
            >
              <Text.BodyText4 bold color="grey90" tag="div">
                {step.title}
              </Text.BodyText4>
              <Text.BodyText4 color="grey70" tag="div">
                {step.body}
              </Text.BodyText4>
            </div>
          </li>
        )
      })}
    </ol>
  )
}

export default StepTimeline
